import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import UIImage from 'UIComponents/image/UIImage';
import imageUrls from '../images/imageUrls';
import { devices } from '../styles/viewports.styles';
const HubSpotAcademy = styled(UIImage).withConfig({
  displayName: "AcademyLogo__HubSpotAcademy",
  componentId: "sc-1ipkfct-0"
})(["display:none;@media ", "{display:inline-block;width:13rem;}"], devices.desktop);
export const AcademyLogo = () => {
  const url = imageUrls.academyLogo;
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(HubSpotAcademy, {
      alt: "HubSpot Academy",
      height: 40,
      responsive: false,
      src: url
    })
  });
};